module.exports = __webpack_public_path__ + "media/images/cnu-color-4d14bf35.png";